<template>
    <section class="configurations-page">
        <section class="title">
            <h1>Permissões - {{role}}</h1>
            <p>Aqui está todas as opções para personalização do uso do sistema.</p>
        </section>
        <section class="cards">
            <section>
                <div class="items" v-for="(permission, index) in permissions" :key="index">
                    <h3>{{permission.title}}</h3>
                    <div class="item" v-for="(item, index) in permission.items" :key="index">
                        <div>{{item.label}}</div>
                        <div class="control-check">
                            <ui-switch :list="true" name="item-1" :id="item.key" :val="item.key" v-model="permissionsSelected" />
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <section class="control-float">
            <button type="button" :class="indicator" @click.prevent="updateRoles()">Salvar alterações</button>
        </section>
    </section>
</template>

<script>
    import { permissions } from "@/services"
    import mixinAutoResize from "../../../../mixins/auto-resize.js";
    import { uiSwitch } from "@/components/index.js";
    export default {
        name: 'login',
        components: { uiSwitch, },
        mixins: [ mixinAutoResize ],
        data() {
            return {
                permissions: [
                    {
                        title: 'Configurações',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Gerenciar configurações',
                                key: 'config_manager',
                            },
                            {
                                label: 'Gerenciar tipos de usuários',
                                key: 'config_user_types',
                            },
                            {
                                label: 'Gerenciar permissões de usuários',
                                key: 'config_permissions_user',
                            },
                            {
                                label: 'Outras configurações',
                                key: 'config_others',
                            },
                        ]
                    },
                    {
                        title: 'Curriculo',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Editar currículo',
                                key: 'edit_my_curriculum',
                            },
                        ]
                    },
                    {
                        title: 'Usuários',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Listar',
                                key: 'users_list',
                            },
                            {
                                label: 'Adicionar',
                                key: 'users_add',
                            },
                            {
                                label: 'Editar',
                                key: 'users_edit',
                            },
                            {
                                label: 'Excluir',
                                key: 'users_delete',
                            },
                            {
                                label: 'Bloquear',
                                key: 'users_block',
                            },
                        ]
                    },
                    {
                        title: 'Chamados',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Listar todos',
                                key: 'tickets_list',
                            },
                            {
                                label: 'Listar apenas criado pelo usuário',
                                key: 'tickets_list_my',
                            },
                            {
                                label: 'Listar apenas de responsabilidade do usuário',
                                key: 'tickets_list_my_responsibility',
                            },
                            {
                                label: 'Visualizar',
                                key: 'ticket_view',
                            },
                            {
                                label: 'Adicionar',
                                key: 'tickets_add',
                            },
                            {
                                label: 'Editar',
                                key: 'ticket_edit',
                            },
                            {
                                label: 'Excluir',
                                key: 'ticket_delete',
                            },
                            {
                                label: 'Alterar responsável',
                                key: 'ticket_edit_owner',
                            },
                            {
                                label: 'Alterar status',
                                key: 'ticket_edit_status',
                            },
                        ]
                    },
                    {
                        title: 'Comentários',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Listar',
                                key: 'comments_list',
                            },
                            {
                                label: 'Adicionar',
                                key: 'comments_add',
                            },
                            {
                                label: 'Editar',
                                key: 'comment_edit',
                            },
                            {
                                label: 'Excluir',
                                key: 'comment_delete',
                            },
                        ]
                    },
                    {
                        title: 'Vagas de Emprego',
                        icon: 'fal fa-hard-hat',
                        items: [
                            {
                                label: 'Listar',
                                key: 'jobs_list',
                            },
                            {
                                label: 'Adicionar',
                                key: 'job_add',
                            },
                            {
                                label: 'Editar',
                                key: 'job_edit',
                            },
                            {
                                label: 'Atualizar Status',
                                key: 'job_update_status',
                            },
                            {
                                label: 'Excluir',
                                key: 'job_delete',
                            },
                            {
                                label: 'Candidatar-se para vaga',
                                key: 'job_candidate',
                            },
                            {
                                label: 'Ver candidados da vaga',
                                key: 'job_view_candidates',
                            },
                            {
                                label: 'Ver currículo do candidato',
                                key: 'job_candidate_view_curriculum',
                            },
                        ]
                    }
                ],
                permissionsSelected: [],
                role: null,
                load: false,
                loadUpdate: false,
            }
        },
        computed: {
            indicator(){
                return this.loadUpdate ? 'loading' : ''
            }
        },
        methods: {
            getPermissions(){
                permissions.getByRole(this.role).then( response => {
                    this.permissionsSelected = Object.keys(response.data)
                })
            },
            updateRoles(){
                const data = {
                    permissions: this.permissionsSelected,
                    role: this.role,
                }
                this.loadUpdate = true
                permissions.addToRole(data).then( () => {
                    this.loadUpdate = false
                })
            }
        },
        created(){
            this.role = this.$route.params.role
            this.getPermissions()
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
